'use client'

import { useTranslation } from '@shared/config/i18n'

import { BottomSheetContent, BottomSheetHeader, Typography, VStack } from '@podo-app/design-system-temp'

type Props = {
  onKakaoLoginWithAccountSelection: () => void
  onChatbotConsultation?: () => void
}

const KakaoLoginOptionsBottomSheet = ({ onKakaoLoginWithAccountSelection, onChatbotConsultation }: Props) => {
  const t = useTranslation()

  const handleKakaoLoginWithSelection = () => {
    onKakaoLoginWithAccountSelection()
  }

  const handleChatbotConsultation = () => {
    onChatbotConsultation?.()
  }

  return (
    <BottomSheetContent size="hug">
      <VStack className="h-full justify-between">
        <BottomSheetHeader className="flex flex-col">
          <VStack className="gap-0 w-full">
            <button className="w-full py-5" onClick={handleChatbotConsultation}>
              <Typography size="h3">{t('common.auth.chatbotConsultation')}</Typography>
            </button>

            <button className="w-full py-5" onClick={handleKakaoLoginWithSelection}>
              <Typography size="h3">{t('common.auth.otherKakaoLogin')}</Typography>
            </button>
          </VStack>
        </BottomSheetHeader>
      </VStack>
    </BottomSheetContent>
  )
}

export default KakaoLoginOptionsBottomSheet
